import React from 'react'
import './style.css'

const HeaderTopbar = () => {
    return(	
        <div className="topbar">
            <div className="container">
                <div className="row">
                    <div className="col col-md-12 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul>
                                <li><i className="fi flaticon-call"></i><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></li>
                                <li><i className="fi flaticon-envelope"></i><a href="mailto:info@theedarulqurran.com">info@theedarulqurran.com</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopbar;